import ItemCardContainer from './ItemCard.container';
import ItemCard from './ItemCard';
export default ItemCardContainer(ItemCard);
